import { BuildingAndFloor } from './BuildingAndFloor'

export function FloorMapsView() {
  return <BuildingAndFloor page="floor-plan"></BuildingAndFloor>
}
